import React, { useEffect } from 'react';

import { BrowserRouter, Redirect, Route, Switch, useLocation } from 'react-router-dom';

// import Home from './views/Home';
import Spero from './views/Spero';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const App = () => {
  useEffect(() => {
    const navbar = document.querySelector('.Topbar');
    if (!navbar) {
      return;
    }
    navbar.style.animation = 'none'; // Reset animation
    setTimeout(() => {
      navbar.style.animation = 'slideInFromTop 0.5s ease-out forwards';
    }, 50); // Small delay to ensure reset
  }, []); // Run only once on mount

  return (
    <div className="app">
      <BrowserRouter>
        <ScrollToTop />
        <Switch>
          <Route path="/home" component={Spero} />
          <Redirect from="/*" to="/home" />
        </Switch>
      </BrowserRouter>
    </div>
  );
};

export default App;
